// extracted by mini-css-extract-plugin
module.exports = {"navBackground":"#1d66d4","menuText":"rgba(255,255,255,.75)","menuActiveText":"#fff","navBarMaxWidth":"160px","navBarMinWidth":"65px"};